// Benefits component - Converted from components/Benefits.vue
// Benefits section with background and icon boxes
import React from 'react';
import benefitsBg from '../assets/images/resources/benifits_bg.png';

interface Benefit {
  icon: string;
  title: string;
}

const Benefits: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  // Benefits data - converted from Vue benefits array
  const benefits: Benefit[] = [
    {
      icon: 'icon-tractor',
      title: 'Nous Intégrons Des Technologies Innovantes.'
    },
    {
      icon: 'icon-harvest',
      title: 'Agriculteurs Et Experts Du Secteur.'
    },
    {
      icon: 'icon-watering-can',
      title: 'Nous Sommes Une Entreprise Certifiée Et Reconnue.'
    },
    {
      icon: 'icon-log',
      title: 'Nous assurons des livraisons dans toutes les régions.'
    }
  ];

  return (
    <section
      className="benefits"
      style={{
        marginTop: '100px',
        minHeight: '788px',
        display: 'flex',
        alignItems: 'center',
        ...(style || {})
      }}
    >
      <div 
        className="benefits_bg" 
        style={{ backgroundImage: `url(${benefitsBg})` }}
      />
      <div className="container w-100">
        <div className="row">
          <div className="col-xl-4">
            <div className="block-title text-left mt-5">
              <p>Nos avantages</p>
              <h3>Excellence en céréaliculture</h3>
            </div>
          </div>
          <div className="col-xl-8 d-flex">
            <div className="my-auto">
              <div className="benefits_text">
                <p>
                  Chez Leaders Agro Elite Tunisie, nous nous engageons à offrir des produits
                  agricoles de premier choix, en mettant particulièrement l&apos;accent sur nos
                  céréales et notre blé de qualité supérieure. Nous veillons à préserver
                  l&apos;environnement tout en soutenant activement les communautés locales, car
                  nous croyons que la durabilité et la qualité vont de pair.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="benefits_bottom_part">
          <div className="row">
            {benefits.map((benefit, index) => (
              <div key={index} className="col-xl-3 col-lg-3 col-md-6">
                <div 
                  className="benefits_single wow fadeInUp" 
                  data-wow-delay={`${(index + 1) * 100}ms`}
                >
                  <div className="icon-box">
                    <span className={benefit.icon}></span>
                  </div>
                  <h3>{benefit.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
